import TagManager from 'react-gtm-module';

export interface TrackDealsStripClickProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    linkText: string;
    index: number;
  };
}

export const trackDealsStripClick = ({ data }: TrackDealsStripClickProps) => {
  const { interactionLocation, linkUrl, linkText, index } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_deals_strip',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        index,
      },
    },
  });
};
